import { Link } from "react-router-dom";
import { RechtSeitenRahmen } from "@/components/recht/RechtSeitenRahmen";
import { ErklaerungsFormular } from "@/components/recht/ErklaerungsFormular";
import { KONTO_PFAD } from "@/lib/vertragErklaerung";

// Widerrufsbutton (§ 356a BGB, Sitzung „Aufräumen“, 14.10.2026): aus der Fußzeile „Vertrag widerrufen“, ohne
// Anmeldung. Die Function `vertrag-erklaerung` legt die Erklärung an und bestätigt den Eingang per E-Mail.
const VertragWiderrufen = () => (
  <RechtSeitenRahmen
    titel="Vertrag widerrufen"
    beschreibung="Widerrufe einen Vertrag bei MusiKonzept innerhalb der Widerrufsfrist auch ohne Anmeldung. Du bekommst sofort eine Eingangsbestätigung."
    pfad="/vertrag-widerrufen"
  >
    <div className="space-y-8">
      <div className="space-y-3">
        <h1 className="text-4xl font-bold text-primary">Vertrag widerrufen</h1>
        <p className="text-muted-foreground leading-relaxed">
          Du hast einen Vertrag bei uns geschlossen und möchtest ihn innerhalb der Widerrufsfrist widerrufen? Hier geht das
          ohne Anmeldung. Nach dem Absenden bekommst du sofort eine Eingangsbestätigung mit Datum und Uhrzeit, auf der
          nächsten Seite und per E-Mail. Alles zu Frist und Folgen steht in der{" "}
          <Link to="/widerruf" className="font-semibold text-[#227277] underline underline-offset-2">
            Widerrufsbelehrung
          </Link>
          .
        </p>
        <p className="text-sm text-muted-foreground">
          Eine laufende Mitgliedschaft beenden? Das geht in deinem Bereich unter{" "}
          <Link to={KONTO_PFAD} className="font-semibold text-[#227277] underline underline-offset-2">
            „Mein Account“
          </Link>{" "}
          → „Abo & Rechnungen“ → „Abo kündigen“.
        </p>
      </div>
      <div className="rounded-2xl border border-border bg-card p-5 shadow-sm sm:p-8">
        <ErklaerungsFormular />
      </div>
    </div>
  </RechtSeitenRahmen>
);

export default VertragWiderrufen;
